module.exports = __webpack_public_path__ + "assets/img/not-template.b6948b91.png";